import { CommonModule } from "@angular/common";
import { Component, inject, input, output } from "@angular/core";
import { CalendarErrorRecordItem } from "@modules/global-dashboard/models/global-dashboard-interface";
import { GlobalDashboardEventsService } from "@modules/global-dashboard/services/global-dashboard-events.service";

import { IconModule } from "@shared/components/icon/icon.module";
import { NoItemsLayoutModule } from "@shared/components/no-items-layout/no-items-layout.module";

@Component({
	selector: "app-calendar-error-side-panel",
	standalone: true,
	imports: [CommonModule, IconModule, NoItemsLayoutModule],
	templateUrl: "./calendar-error-side-panel.component.html",
	styleUrl: "./calendar-error-side-panel.component.scss"
})
export class CalendarErrorSidePanelComponent {
	closeCalendarErrorSidePanel = output<boolean>();
	calendarErrorRecords = input<CalendarErrorRecordItem[]>([]);

	searchText = "";
	activeTabIndex = 0;

	readonly tabs = ["All", "Milestones errors", "Configuration errors"];

	get filteredCalendarErrorRecordsItems(): CalendarErrorRecordItem[] {
		let records = this.calendarErrorRecords();

		if (this.activeTabIndex === 1) {
			records = this.calendarErrorRecords().filter(record => record.errorType === "Milestone error");
		}
		if (this.activeTabIndex === 2) {
			records = this.calendarErrorRecords().filter(record => record.errorType === "Configuration error");
		}

		return this.searchCalendarErrorRecords(records);
	}

	/** IMPORTS DECLARATION */
	private globalDashboardEventsService = inject(GlobalDashboardEventsService);

	/**
	 * Use to search calendar error records based on the search text
	 * @param calendarErrorRecords: calendar errors list
	 * @returns filtered calendar error list
	 */
	searchCalendarErrorRecords(calendarErrorRecords: CalendarErrorRecordItem[]): CalendarErrorRecordItem[] {
		const searchTerm = this.searchText.trim().toLowerCase();

		if (!searchTerm) {
			return calendarErrorRecords;
		}

		return calendarErrorRecords.filter(record =>
			[record.title, record.subtitle, record.errorDescription, record.errorType].some(value =>
				value.toLowerCase().includes(searchTerm)
			)
		);
	}

	/**
	 * Checks selected tab
	 * @param index: tab selected index
	 */
	selectedTab(index: number): void {
		this.activeTabIndex = index;
	}

	/**
	 * Redirect user to Calendar page
	 * @param payGroupId
	 * @param legalEntityId
	 * @param customerName
	 * @param customerId
	 */
	goToCalendar(payGroupId: string, legalEntityId: string, customerName: string, customerId: string): void {
		this.globalDashboardEventsService.navigateToCalendarPage(payGroupId, legalEntityId, customerName, customerId);
	}

	/**
	 * Emits false to close the calendar error side panel
	 */
	closePanel(): void {
		this.closeCalendarErrorSidePanel.emit(false);
	}
}
